const eventConstants = Object.freeze({
  STANDALONE: 'Standalone',
  MAIN_APP: 'Main App',
  OPEN_DASHBOARD: 'Open Dashboard',
  RENDERED_SHIFT_LIST: 'Client App | Rendered Shift List',
  RENDERED_LOADING_ORDER_LIST: 'Client App | Rendered Loading Order List',
  RENDERED_DELIVERY_ORDER_LIST: 'Client App | Rendered Delivery Order List',
  OPEN_OPTIMIZED_DELIVERY_ORDER_MODAL: 'Open Optimized Delivery Order Modal',
  RENDERED_RECURRING_ORDER_LIST: 'Client App | Rendered Recurring Order List',
});

// Event Naming Conventions: [feature_name].[action_name]

const BULK_PLANT = {
  Bulk_Tank_Inventory_Details_Opened: 'Bulk_Plant.Bulk_Tank_Inventory_Details_Opened',
  Bulk_Warehouse_Inventory_Details_Opened: 'Bulk_Plant.Bulk_Warehouse_Inventory_Details_Opened',
  Bulk_Tank_Start_Inventory_Updated: 'Bulk_Plant.Bulk_Tank_Start_Inventory_Updated',
  Details_Modal_Opened_From_Bulk_Plant_Inventory_Details_Page:
    'Bulk_Plant.Details_Modal_Opened_From_Bulk_Plant_Inventory_Details_Page',
};

const RECURRING_ORDER = {
  Recurring_Rule_Created_For_Delivery_Order_Only:
    'Recurring_Order.Recurring_Rule_Created_For_Delivery_Order_Only',
  Recurring_Rule_Created_For_Both_Delivery_And_Loading_Order:
    'Recurring_Order.Recurring_Rule_Created_For_Both_Delivery_And_Loading_Orders',
};

const INVOICE = {
  Invoice_Created: 'Invoice Created',
  Invoice_Generated: 'Invoice Generated',
  Invoice_Credited: 'Invoice Credited',
  Invoice_Re_Billed: 'Invoice Re-billed',
  Invoice_Re_Billed_Generated: 'Invoice Re-billed Generated',
  Invoice_Re_Billed_Created: 'Invoice Re-billed Created',
  Invoice_Synced: 'Invoice Synced',
};

const ROUTE_BUILDER = {
  Route_Created_From_Route_Builder: 'Route_Builder.Route_From_Route_Builder.Created',
  Route_Dispatched_From_Route_Builder: 'Route_Builder.Route_From_Route_Builder.Dispatched',
};

export { eventConstants, BULK_PLANT, RECURRING_ORDER, ROUTE_BUILDER, INVOICE };
